/**
 * @param {Object} vueInstance : this
 * @param {String} type : Toast type ['success', 'danger']
 * @param {String} message : Toast message
 */
function showToast({ vueInstance, type, message }) {
	switch (type) {
		case 'success':
			vueInstance.$notify({
				// message: `<div>Your model <b>${dataObj?.model_name}</b> has been trained!</div> Please go to detector to try it out`,
				message: message,
				timeout: 7000,
				icon: 'ni ni-bell-55',
				type: 'success',
			});
			break;
		case 'danger':
			vueInstance.$notify({
				// message: `<div>Your model <b>${dataObj?.model_name}</b> failed to train!</div> Please try again or contact your administrator`,
				message: message,
				timeout: 7000,
				icon: 'ni ni-bell-55',
				type: 'danger',
			});
			break;
		case 'warning':
			vueInstance.$notify({
				// message: `<div>Your model <b>${dataObj?.model_name}</b> failed to train!</div> Please try again or contact your administrator`,
				message: message,
				timeout: 7000,
				icon: 'ni ni-bell-55',
				type: 'warning',
			});
			break;

		default:
			break;
	}
}

export default showToast;
